export default __webpack_public_path__ + "static/media/info-3.c2e557b0.png";